import React from "react";
import { useOutletContext } from "react-router-dom";
import Certificates from "./Component/Certificates";
import type { PortfolioSiteData } from "../types/resume";
import Seo from "../components/Seo";

const CertificatesWrapper = () => {
  const { data } = useOutletContext<{ data: Partial<PortfolioSiteData> }>();
  if (!data.certificates) {
    return null;
  }

  return (
    <>
      <Seo
        title="Certificates — Efwan Rizaldi"
        description="Certifications earned by Efwan Rizaldi including Google AI Professional, frontend and full-stack development tracks."
        path="/certificates"
      />
      <div className="min-h-screen">
        <Certificates data={data.certificates} />
      </div>
    </>
  );
};

export default CertificatesWrapper;
